export interface ExemptionsAdd {
    departureAirport: string;
    arrivalAirport: string;
    validSince: Date;
    validUntil: Date;
}